import React, { useState } from 'react';

// project-imports
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';
import { useCoursesContext } from '../../context/courses_context';
import SEO from '../../common/SEO';
import FooterOne from '../../common/footer/FooterOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AboutUsChannel from '../../components/about/AboutUsChannel';
import AboutUsOneService from '../../components/about-us-one/AboutUsOneService';
import HeaderLandingPage from '../../common/header/HeaderLandingPage';
import AboutUsPageSection from '../../components/about/AboutUsPageSection';
import HomeTwoTestimonial from '../../components/home-two/HomeTwoTestimonial';
import HeaderTwo from '../../common/header/HeaderTwo';
import BookConsultationSection from '../../components/book-consultation/BookConsultationSection';
import TestimonialSectionSalesforceV2 from '../../components/testimonial-section/TestimonialSectionSalesforceV2';
import TestimonialSectionOneOnOneConsultation from '../../components/testimonial-section/TestimonialSectionOnOneOneConsultation';
import SalesforceOffering from '../../components/salesforce/SalesforceOffering';

const BookOneOnOneSession = () => {

    // State variable initialization
    const [stencilLoading, setStencilLoading] = useState(true);

    // Loading timeout
    setTimeout(() => {
        setStencilLoading(false);
    }, 1000);

    return (
        <>
            <SEO title="Get Free Consultation | Longswitch Academy" url={process.env.PUBLIC_URL + "/get-free-consultation"} /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.ABOUT_US)}

            {/* <HeaderLandingPage setFilteredCourses={setFilteredCourses} searchDisable={true} /> */}
            <HeaderTwo searchDisable={true} />

            <BreadcrumbOne
                title="Get Free Consultation" // Breadcrumb title 
                rootUrl="/"
                parentUrl="Home"
                currentUrl="Get Free Consultation"
            />

            {/* Book Consultation component */}
            <BookConsultationSection />

            {/* Service component */}
            <AboutUsOneService />

            {/* Our Review component */}
            {/* <TestimonialSectionOneOnOneConsultation stencilLoading={stencilLoading} /> */}
            <SalesforceOffering />


            {/* Channel component */}
            <AboutUsChannel />

            {/* Testimonial component */}
            <HomeTwoTestimonial />

            {/* Footer component */}
            <FooterOne />
        </>
    )
}

export default BookOneOnOneSession;